import {
    apiRequest,
    jenisDiklatCreate, 
    jenisDiklatUpdate
} from "../../../../../services/adapters/kepegawaian/jenisDiklatService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", jenisDiklatCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", jenisDiklatUpdate, {
            body: query
        }, true)
    }

}

export default CreateRepository